module.exports = __webpack_public_path__ + "static/sylaba-1e6215f1635b90bf220995a69dcbbb79.png";